import * as React from "react";
import classnames from "classnames";
import { PropertyDetails } from "../../../core/api/models/project";
import {
  AppPermissions,
  ProposedProperty,
  useHasPermission,
} from "../../../core";
import { LeadRequirement } from "../../../core/api/models/requirement";

import PropertyDetailPage from "../../property-details/PropertyDetailPage";
import RequirementPropertyDetailPage from "../../requirement/components/RequirementPropertyDetail";
import SortByAscendingIcon from "../../../assets/images/sort-by-ascending-icon";
import SortByDescendingIcon from "../../../assets/images/sort-by-descending-icon";
import ListViewIcon from "../../../assets/images/list-view-icon";
import MapViewIcon from "../../../assets/images/map-view-icon";
import ShortListedPropertiesMapView from "./shortListed-properties-map-view";
import ShortlistedPropertiesListView from "./shortListed-properties-list-view";

const ShortListedProperty: React.FunctionComponent<{
  requirementId: string;
  sortList: any[];
  onSelect: (propertys: PropertyDetails[]) => void;
  onSelectExcludeFloor: ((propertys: PropertyDetails[]) => void) | undefined;
  onSelectExcludePhotoGallery: ((propertys: PropertyDetails[]) => void) | undefined;
  onSelectExcludeFurnishing: ((propertys: PropertyDetails[]) => void) | undefined;
  selectedProperties: PropertyDetails[];
  selectedExcludeFloorDetails: PropertyDetails[];
  selectedExcludePhotoGalleryDetails: PropertyDetails[];
  selectedExcludeFurnishingDetails: PropertyDetails[];
  versionList: LeadRequirement[];
  proposedProperties: ProposedProperty[] | undefined;
  isSelectedShortListedProperty: boolean | undefined;
  onUpdateFloorplanFurnishing: ((propertyId: string, value: string) => void) | undefined;
  selectedFloorplanFurnishing: { [key: string]: string } | undefined;
  showThirdColumn: { [key: string]: boolean } | undefined;
  setShowThirdColumn: React.Dispatch<
    React.SetStateAction<{ [key: string]: boolean }>
  > | undefined;
}> = (props) => {
  const [groupByList, setGroupByList] = React.useState<any>();
  const [seletedView, setSelectedView] = React.useState("list");
  const [sortOrder, setSortOrder] = React.useState("asc");
  const [requirementId, setRequirementId] = React.useState("");
  const [locations, setLocations] = React.useState<
    { lat: number; lng: number; name: string }[] | undefined
  >([]);
  const [projectDetailModal, setProjectDetailModal] = React.useState<{
    isOpen?: boolean;
    projectId?: string;
  }>({});


  const [propertyDetailModal, setPropertyDetailModal] = React.useState<{
    isOpen?: boolean;
    propertyId?: string;
  }>({});

  const canViewProject = useHasPermission(AppPermissions.ViewProject);
  const canViewProperty = useHasPermission(AppPermissions.ViewProperty);

  const onSort = (sort: string) => {
    setSortOrder(sort);
    const sortList =
      sort === "asc"
        ? props.sortList?.sort((a, b) =>
          a.propertyDetailsFromProject?.projectName?.localeCompare(
            b.propertyDetailsFromProject?.projectName
          )
        )
        : props.sortList?.sort((a, b) =>
          b.propertyDetailsFromProject?.projectName?.localeCompare(
            a.propertyDetailsFromProject?.projectName
          )
        );
    if (!!sortList?.length) {
      const groupList = sortList?.reduce((group: any, product: any) => {
        const { propertyDetailsFromProject } = product;
        const { projectId } = propertyDetailsFromProject;

        group[projectId] = group[projectId] ?? [];
        group[projectId].push(product);
        return group;
      }, {});
      setGroupByList(groupList);
    }
  };

  React.useEffect(() => {
    const groupList = props?.sortList
      ?.sort((a, b) =>
        a.propertyDetailsFromProject?.projectName?.localeCompare(
          b.propertyDetailsFromProject?.projectName
        )
      )
      ?.reduce((group: any, product: any) => {
        const { propertyDetailsFromProject } = product;
        const { projectId } = propertyDetailsFromProject;

        group[projectId] = group[projectId] ?? [];
        group[projectId].push(product);
        return group;
      }, {});

    const tempLocations: { lat: number; lng: number; name: string }[] = [];
    if (groupList && Object.keys(groupList)?.length > 0) {
      Object.keys(groupList)?.map((key, index) => {
        const item = groupList[key]?.find(
          (x: any) => x.propertyDetailsFromProject.projectId === key
        );

        tempLocations.push({
          lat: parseFloat(item?.propertyDetails?.proLatitude),
          lng: parseFloat(item?.propertyDetails?.proLongitude),
          name: (index + 1).toString(),
        });
      });
    }

    setLocations(tempLocations);

    setGroupByList(groupList);
  }, [props.sortList]);

  const applyVersion = (version: number) => {
    let list = props?.sortList || [];
    if (version) {
      list =
        props?.sortList?.filter((x) => x.requirementVersion === version) || [];
    }

    list =
      (sortOrder === "asc"
        ? list?.sort((a, b) =>
          a.propertyDetailsFromProject?.projectName?.localeCompare(
            b.propertyDetailsFromProject?.projectName
          )
        )
        : list?.sort((a, b) =>
          b.propertyDetailsFromProject?.projectName?.localeCompare(
            a.propertyDetailsFromProject?.projectName
          )
        )) || [];

    const groupList = list.reduce((group: any, product: any) => {
      const { propertyDetailsFromProject } = product;
      const { projectId } = propertyDetailsFromProject;

      group[projectId] = group[projectId] ?? [];
      group[projectId].push(product);
      return group;
    }, {});

    const tempLocations: { lat: number; lng: number; name: string }[] = [];
    if (groupList && Object.keys(groupList)?.length > 0) {
      Object.keys(groupList)?.map((key, index) => {
        const item = groupList[key]?.find(
          (x: any) => x.propertyDetailsFromProject.projectId === key
        );

        tempLocations.push({
          lat: parseFloat(item?.propertyDetails?.proLatitude),
          lng: parseFloat(item?.propertyDetails?.proLongitude),
          name: (index + 1).toString(),
        });
      });
    }

    setLocations(tempLocations);

    setGroupByList(groupList);
  };


  return !!props.sortList?.length ? (
    <>
      {!!props?.versionList?.length && (
        <div className="mb-4">
          <span className="font-xs font-weight-semibold mr-2 text-gray-600">
            Requirement Versions
          </span>
          <span
            key={"v0"}
            onClick={() => {
              setRequirementId("");
              applyVersion(0);
            }}
            className={classnames({
              "border border-radius-50 px-2 py-1 font-xs font-weight-semibold rounded-pill mr-2 cursor-pointer": true,
              "border-primary text-white bg-primary": requirementId === "",
            })}
          >
            All
          </span>
          {props?.versionList?.map((item) => {
            return (
              <span
                onClick={() => {
                  setRequirementId(item._id);
                  applyVersion(item.versionNumber!);
                }}
                className={classnames({
                  "border border-radius-50 px-2 py-1 font-xs font-weight-semibold rounded-pill mr-2 cursor-pointer": true,
                  "border-primary text-white bg-primary": requirementId === item._id,
                })}
              >
                V{item.versionNumber}
              </span>
            );
          })}
        </div>
      )}
      {!!(groupByList && Object.keys(groupByList)?.length) ? (
        <>
          <div
            className="py-2 px-4 border-top border-bottom d-flex align-items-center mb-1 project-tab-header justify-content-between"
            style={{ background: "rgba(160, 160, 160, 0.06)" }}
          >
            <div className="d-flex">
              <div className="font-sm text-gray-500">
                <span className="text-gray-700 font-weight-bolder">
                  {props.sortList?.length}
                </span>{" "}
                Properties,{" "}
                <span className="text-gray-700 font-weight-bolder">
                  {groupByList ? Object.keys(groupByList)?.length : 0}
                </span>{" "}
                Projects
              </div>
              <div
                className="inline-flex font-xs text-gray-500 border-left ml-4 pl-4 cursor-pointer"
                onClick={() => onSort(sortOrder === "asc" ? "dece" : "asc")}
              >
                {sortOrder === "asc" ? (
                  <SortByAscendingIcon />
                ) : (
                  <SortByDescendingIcon />
                )}
                <span className="ml-1">Sort</span>
              </div>
            </div>
            <div>
              <ul className="click-tab bg-white d-flex list-unstyled mb-0">
                <li
                  className={classnames({
                    "px-3 py-2 border border-right-0 rounded-left cursor-pointer": true,
                    active: seletedView === "list",
                  })}
                  onClick={() => setSelectedView("list")}
                >
                  <ListViewIcon />
                </li>
                <li
                  className={classnames({
                    "px-3 py-2 border rounded-right cursor-pointer": true,
                    active: seletedView === "map",
                  })}
                  onClick={() => setSelectedView("map")}
                >
                  <MapViewIcon />
                </li>
              </ul>
            </div>
          </div>
          {seletedView === "map" && (
            <ShortListedPropertiesMapView
              groupByList={groupByList}
              locations={locations}
            />
          )}
          {seletedView === "list" && (
            <ShortlistedPropertiesListView
              selectedExcludeFloorDetails={props.selectedExcludeFloorDetails}
              onUpdateFloorplanFurnishing={props.onUpdateFloorplanFurnishing}
              selectedExcludeFurnishingDetails={props.selectedExcludeFurnishingDetails}
              selectedExcludePhotoGalleryDetails={props.selectedExcludePhotoGalleryDetails}
              selectedProperties={props.selectedProperties}
              groupByList={groupByList}
              showThirdColumn={props.showThirdColumn}
              setShowThirdColumn={props.setShowThirdColumn}
              proposedProperties={props.proposedProperties}
              setProjectDetailModal={setProjectDetailModal}
              setPropertyDetailModal={setPropertyDetailModal}
              sortList={props.sortList}
              onSelectHandler={props.onSelect}
              onSelectExcludeFloor={props.onSelectExcludeFloor}
              onSelectExcludePhotoGalleryHandler={props.onSelectExcludePhotoGallery}
              selectedFloorplanFurnishing={props.selectedFloorplanFurnishing}
              onSelectExcludeFurnishingHandler={props.onSelectExcludeFurnishing}
            />
          )}
          {projectDetailModal.isOpen && canViewProject && (
            <RequirementPropertyDetailPage
              onClose={() => setProjectDetailModal({})}
              projectId={projectDetailModal.projectId}
              showDetailsOnly={true}
            ></RequirementPropertyDetailPage>
          )}
          {propertyDetailModal.isOpen && canViewProperty && (
            <PropertyDetailPage
              onClose={() => setPropertyDetailModal({})}
              projectId={propertyDetailModal.propertyId}
            ></PropertyDetailPage>
          )}
        </>
      ) : (
        <div className="py-4 d-flex flex-column align-items-center">
          <i className="icon-box--lg font-xxl bg-orange text-white icon-bulb rounded-circle d-inline-flex justify-content-center align-items-center"></i>
          <div
            className="py-2 font-xs font-weight-semibold text-center my-1"
            style={{ maxWidth: "500px", lineHeight: "21px" }}
          >
            There is no short listed properties for create proposal
          </div>
        </div>
      )}
    </>
  ) : (
    <></>
  );
};

export default ShortListedProperty;
